import axiosAuth from "@/services/axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import { CONSENT_PROPERTY_API } from "./apiRoutes";

interface mutateProps {
  communityId: string;
  propertyId: string;
  data: FieldValues;
}

const mutateUpdateConsent = async ({
  data,
  communityId,
  propertyId
}: mutateProps) => {
  return await axiosAuth.patch(`${CONSENT_PROPERTY_API(communityId, propertyId)}/consent`, data);
};

const useUpdateConsentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateConsent,
    ...queryParams,
  });

export default useUpdateConsentMutation;
